module.exports = __webpack_public_path__ + "static/media/IRN_Errors.9728f12b.svg";